<template>
  <swipeable-bottom-sheet
    class="md:hidden"
    v-if="cartItems.length > 0"
    ref="swipeableBottomSheet"
  >
    <div
      :class="[
        'pan-area w-10',
        isSwipeOpen ? 'mb-4 hidden' : 'mb-0 absolute block',
      ]"
      ref="pan"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        :class="[
          'w-10 m-auto rounded-full bg-primary-50 p-2 transform rotate-180',
          isSwipeOpen ? 'hidden' : 'block',
        ]"
        @click="openSwipeOnClick"
      >
        <path
          d="M19 9l-7 7-7-7"
          fill="none"
          stroke="#9D9D9D"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div
      v-if="!isSwipeOpen"
      @click="openSwipeOnClick"
      class="mt-8 flex justify-center mb-8"
    >
      <p
        @click="updateCartProcess"
        class="bg-new-primary w-3/4 text-white text-center rounded-xxl p-2"
        :style="makeStyles(hasKiosk&&mainButtonRadius, paymentBtnBackground , paymentBtnText)"
      >
        {{ lang["payment"][language] }} {{ totalPriceValueWithCosts }}
      </p>
    </div>
    <div
      :class="[
        'flex w-full fading bg-white fixed z-20 pt-4 rounded-t-xl h-12',
        isSwipeOpen ? 'bg-white' : ' bg-primary-100',
      ]"
    >
      <div
        v-if="processBarIndex != 1"
        @click="previousProcess"
        class="w-full pl-4"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          class="w-8 p-1"
        >
          <path
            d="M10 19l-7-7m0 0l7-7m-7 7h18"
            fill="none"
            stroke="#9D9D9D"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div class="flex justify-end pr-4 w-full">
        <IconCancel
          fill="none"
          stroke="#f86262"
          class="w-8 p-1"
        />
      </div>
    </div>
    <CartProcess test="swipe" />
  </swipeable-bottom-sheet>
</template>

<script>
import SwipeableBottomSheet from "./SwipeableBottomSheet";
import { mapGetters, mapState } from "vuex";
import CartProcess from "../components/CartProcess";
import lang from "../lang";
import IconCancel from "../components/icons/iconCancel.vue";

export default {
  data() {
    return {
      lang: lang,
      colors: "",
    };
  },
  components: {
    SwipeableBottomSheet,
    CartProcess,
    IconCancel
},

  computed: {
    ...mapGetters([
      "isSwipeOpen",
      "processBarIndex",
      "processCurrentName",
      "showTable",
      "processBarCurrentItem",
      "showPayment",
      "showForm",
      "processCurrentName",
      "processStack",
      "language",
      "theme",
      "hasKiosk",
      "menu",
    ]),
    ...mapGetters("Cart", [
      "cartItems",
      "stickerId",
      "totalPriceValueWithCosts",
      "totalPriceValue",
    ]),
    ...mapState(["languageLocales"]),
    ...mapGetters("Theme", ["paymentBtnBackground","mainButtonRadius", "paymentBtnText"]),
  },
  methods: {
    openSwipeOnClick() {
      this.$refs.swipeableBottomSheet.setState("open");
    },
    closeSwipeOnClick() {
      let swipeableBottomSheet = document.getElementById(
        "swipeable-bottom-sheet"
      );
      swipeableBottomSheet.scrollTop = 0;
      this.$refs.swipeableBottomSheet.setState("close");
      this.$store.commit("updateShowPayment", false);
    },
    //  go back to the previeus step if you click on the arrow button inside the cart modal
    previousProcess() {
      let x = document.getElementById("swipeable-bottom-sheet");
      x.scrollTop = 0;
      this.$store.commit("updateProcessBarIndex", this.processBarIndex - 1);
      this.$store.commit(
        "updateProcessBarCurrentItem",
        this.processBarCurrentItem - 2
      );
      this.$store.commit("deleteProcessStack");
      this.$store.commit("deleteButtonStack");
      this.$store.commit("updateShowPayment", false);
      this.$store.commit(
        "updateProcessCurrentName",
        this.processStack[this.processStack.length - 1]
      );
    },
    // check the process of the cart to update it for the next step
    updateCartProcess() {
      this.$store.commit("updateProcessBarCurrentItem", 1);
      this.$store.commit("updateProcessBarIndex", 1);
      this.$store.commit("updateProcessCurrentName", "Category");
      let path;
      let pointer;
      let onClickIndex;
      let routeName;
      let label;
      let processBarUpdate;
      switch (this.processCurrentName) {
        case "Category": {
          // this.$store.commit("updateProcessBarCurrentItem", 1);
          // this.$store.commit("updateProcessBarIndex", 1);
          if (
            this.menu.timeslots_mode == "general" ||
            this.menu.timeslots_mode == "individual"
          ) {
            if (this.menu.pos_mode == "take-out") {
              // path = `/${this.menuHash}/cart/time-slot-selection`;
              // this.$store.commit("updateProcessBarIndex", 1);
              this.$store.commit(
                "updateFloatButtonLabel",
                lang["select_time_slot"][this.language]
              );
              this.$store.commit(
                "updateProcessCurrentName",
                "TimeSlotSelection"
              );
              this.$store.commit("updateProcessStack", "TimeSlotSelection");
            } else {
              if (this.stickerId == 0) {
                this.$store.commit(
                  "updateFloatButtonLabel",
                  lang["select_table"][this.language]
                );

                //   this.$store.commit("updateProcessBarIndex", 2);

                this.$store.commit(
                  "updateProcessCurrentName",
                  "TableSelection"
                );
                this.$store.commit("updateProcessStack", "TableSelection");
                this.$store.commit("updateShowTable", true);
              } else {
                //   path = `/${this.menuHash}/cart/user-details`;
                if (this.menu.customer_details_disabled == false) {
                  this.$store.commit(
                    "updateFloatButtonLabel",
                    lang["leave_contact_details"][this.language]
                  );
                  // this.$store.commit("updateProcessBarCurrentItem", 5);
                  // this.$store.commit("updateProcessBarIndex", 3);
                  this.$store.commit("updateProcessCurrentName", "UserDetails");
                  this.$store.commit("updateProcessStack", "UserDetails");
                } else {
                  this.$store.commit(
                    "updateFloatButtonLabel",
                    lang["continue_to_payment"][this.language]
                  );
                  this.$store.commit("updateProcessCurrentName", "Payment");
                  this.$store.commit("updateProcessStack", "Payment");
                  // this.$store.commit("updateProcessBarCurrentItem", 3);
                  // this.$store.commit("updateProcessBarIndex", 2);
                  this.$store.commit("updateShowPayment", true);
                }
              }
            }
          } else {
            if (this.menu.pos_mode == "take-out") {
              if (this.menu.customer_details_disabled == false) {
                this.$store.commit(
                  "updateFloatButtonLabel",
                  lang["leave_contact_details"][this.language]
                );
                this.$store.commit("updateProcessCurrentName", "UserDetails");
                this.$store.commit("updateShowForm", true);
                this.$store.commit("updateProcessStack", "UserDetails");
              } else {
                if (
                  this.menu.timeslots_mode == "simple" ||
                  this.menu.timeslots_mode == ""
                ) {
                  this.$store.commit(
                    "updateFloatButtonLabel",
                    lang["leave_contact_details"][this.language]
                  );
                  this.$store.commit("updateProcessCurrentName", "UserDetails");
                  this.$store.commit("updateProcessStack", "UserDetails");
                } else {
                  this.$store.commit(
                    "updateFloatButtonLabel",
                    lang["continue_to_payment"][this.language]
                  );
                  this.$store.commit("updateProcessCurrentName", "Payment");
                  this.$store.commit("updateProcessStack", "Payment");
                }
              }
            } else {
              if (this.stickerId == 0) {
                path = `/${this.menuHash}/cart/table-selection`;
                this.$store.commit(
                  "updateFloatButtonLabel",
                  lang["select_table"][this.language]
                );
                this.$store.commit(
                  "updateProcessCurrentName",
                  "TableSelection"
                );
                this.$store.commit("updateProcessStack", "TableSelection");
              } else {
                if (this.menu.customer_details_disabled == false) {
                  path = `/${this.menuHash}/cart/user-details`;
                  this.$store.commit(
                    "updateFloatButtonLabel",
                    lang["leave_contact_details"][this.language]
                  );
                  this.$store.commit("updateProcessCurrentName", "UserDetails");
                  this.$store.commit("updateProcessStack", "UserDetails");
                  //   this.$store.commit("updateProcessBarCurrentItem", 3);
                  //   this.$store.commit("updateProcessBarIndex", 2);
                  this.$store.commit("updateShowForm", true);
                } else {
                  path = `/${this.menuHash}/cart/payment`;
                  this.$store.commit("updateShowTable", false);
                  this.$store.commit(
                    "updateFloatButtonLabel",
                    lang["continue_to_payment"][this.language]
                  );

                  this.$store.commit(
                    "updateButtonStack",
                    lang["continue_to_payment"][this.language]
                  );
                  //   this.$store.commit("updateProcessBarCurrentItem", 3);
                  //   this.$store.commit("updateProcessBarIndex", 2);
                  this.$store.commit("updateProcessCurrentName", "Payment");
                  this.$store.commit("updateProcessStack", "Payment");
                  this.$store.commit("updateShowPayment", true);
                }
              }
            }
          }
          return {
            visibility: true,
            EnablePossible: pointer,
            path: path,
            label: label,
            labelPosition: "justify-center",
            showIcon: true,
            showItems: false,
            onClickIndex: onClickIndex,
            routeName: routeName,
            processBarUpdate: processBarUpdate,
          };
        }
      }
    },
  },
};
</script>

<style></style>
